import { FC } from 'react';

type BrokerLocationIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BrokerLocationIcon: FC<BrokerLocationIconProps> = ({
  width = 48,
  height = 48,
  color = '#D25D3E',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M44 20V18.435C44 14.5557 44 12.6161 42.8284 11.411C41.6568 10.2059 39.7712 10.2059 36 10.2059H31.8428C30.008 10.2059 29.9928 10.2023 28.343 9.37668L21.6798 6.04228C18.8977 4.65008 17.5066 3.95398 16.0248 4.00236C14.5429 4.05074 13.1975 4.83616 10.5069 6.40702L8.05116 7.84074C6.07478 8.99458 5.08658 9.57152 4.54328 10.5313C4 11.4911 4 12.6599 4 14.9975V31.4314C4 34.5028 4 36.0386 4.68452 36.8934C5.14002 37.462 5.77832 37.8444 6.484 37.9712C7.54452 38.1616 8.84296 37.4036 11.4397 35.8874C13.2031 34.858 14.9002 33.7888 17.0097 34.0788C18.7774 34.3216 20.42 35.437 22 36.2276" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 4V34" stroke={color} strokeWidth="2.4" strokeLinejoin="round"/>
    <path d="M30 10V19" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M36.6166 43.367C36.183 43.773 35.6034 44 35.0002 44C34.397 44 33.8174 43.773 33.3838 43.367C29.4126 39.626 24.091 35.447 26.6862 29.3796C28.0894 26.0992 31.4578 24 35.0002 24C38.5426 24 41.911 26.0992 43.3142 29.3796C45.9062 35.4392 40.5976 39.6388 36.6166 43.367Z" stroke={color} strokeWidth="2.4"/>
    <path d="M35 33H35.018" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
